import { gql, TypedDocumentNode, useQuery } from '@apollo/client';
import { MobileNavigator, MobileNavigatorVariables } from '../../generated/types';
import { throwQueryError } from '../../lib/apollo/throwQueryError';

const LIST_NAVIGATOR_UNIT_SUBCATEGORY_FRAGMENT = gql`
  fragment ListNavigatorUnitSubcategoryFragment on NavigatorUnitListItem {
    id
    title
    href
    type
  }
`;

const LIST_NAVIGATOR_UNIT_FRAGMENT = gql`
  fragment ListNavigatorUnitFragment on ListNavigatorUnit {
    header
    subcategories: list {
      ...ListNavigatorUnitSubcategoryFragment
    }
  }
  ${LIST_NAVIGATOR_UNIT_SUBCATEGORY_FRAGMENT}
`;

const EDITORIAL_NAVIGATOR_UNIT_FRAGMENT = gql`
  fragment EditorialNavigatorUnitFragment on EditorialNavigatorUnit {
    anchorText
    headline
    href
    imageSrc: image_source
    imageAlt: image_alt
  }
`;

const MOBILE_NAV_V2_MENU_QUERY: TypedDocumentNode<MobileNavigator, MobileNavigatorVariables> = gql`
  query MobileNavigator {
    mobileNavigator: navigator(platform: MOBILE) {
      tabs: items {
        id
        name
        tabHeaderHref: href
        units {
          ...ListNavigatorUnitFragment
          ...EditorialNavigatorUnitFragment
        }
      }
    }
  }
  ${LIST_NAVIGATOR_UNIT_FRAGMENT}
  ${EDITORIAL_NAVIGATOR_UNIT_FRAGMENT}
`;

export const useMobileNavV2Query = () => {
  const { data, loading, error } = useQuery(MOBILE_NAV_V2_MENU_QUERY, {});

  if (error) throwQueryError(error);

  return { navigator: data?.mobileNavigator, loading };
};
